import { loadTranslations } from 'react-redux-i18n'
import { store } from '../../../../app/store'

store.dispatch(
  loadTranslations({
    en: {
      ...store.getState().i18n.translations.en,
      common: {
        ...store.getState().i18n.translations.en.common,
        popup: {
          ...store.getState().i18n.translations.en.common.popup,
          popupFactsheet: {
            TITLE: 'Download FiinGate Factsheet',
          },
        },
      },
    },
    vi: {
      ...store.getState().i18n.translations.vi,
      common: {
        ...store.getState().i18n.translations.vi.common,
        popup: {
          ...store.getState().i18n.translations.vi.common.popup,
          popupFactsheet: {
            TITLE: 'Tải FiinGate Factsheet',
          },
        },
      },
    },
  }),
)
